import { useTranslation } from 'react-i18next';
import { SupportedCurrencies } from 'vopay';
import { Title } from 'UI';

type SetUpTransferTitleProps = {
  isUpdate: boolean;
  /** Named only when the overview shows a tab per currency. */
  currency?: SupportedCurrencies;
};

export default function SetUpTransferTitle({ isUpdate, currency }: SetUpTransferTitleProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AutoBalanceTransfer.SetUpTransfer' });

  if (!currency) {
    return (
      <Title>
        {isUpdate
          ? t('updateTitle', { defaultValue: 'Update Auto Balance Transfer' })
          : t('title', { defaultValue: 'Set Up Auto Balance Transfer' })}
      </Title>
    );
  }

  return (
    <Title>
      {isUpdate
        ? t('updateTitleCurrency', { defaultValue: 'Update {{currency}} Auto Balance Transfer', currency })
        : t('titleCurrency', { defaultValue: 'Set Up {{currency}} Auto Balance Transfer', currency })}
    </Title>
  );
}
